import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backdrop", "modal"]

  open() {
    this.backdropTarget.classList.remove("hidden")
    this.modalTarget.classList.remove("hidden")
  }

  close() {
    this.backdropTarget.classList.add("hidden")
    this.modalTarget.classList.add("hidden")
  }
}
